import axios from "axios";
import { API_URL, getAuthHeader } from ".";
import { ScheduledEvent } from "../Models/ScheduleEvent";
import { ContactForm } from "../Models/ContactForm";

class ScheduleEventsApi {
  static getEvents() {
    return axios.get<ScheduledEvent[]>(
      `${API_URL}/api/ScheduleEvents/GetEvents`,
      getAuthHeader()
    );
  }
  static requestDemo(request: ContactForm) {
    return axios.post<boolean>(
      `${API_URL}/api/ScheduleEvents/RequestDemo`,
      request
    );
  }
}

export default ScheduleEventsApi;
